// extracted by mini-css-extract-plugin
export default {"corpSubCard":"oWcfdWKWLvD974WvGG9i","corpSubCardHeader":"_v3yYU0KE61lfbfPXSmt","corpSubCardSubtitle":"Lsr24CJEnXa_7R7C0n54","topBarCorp":"qSrPG7FoJUq7MVaj8Fqd"};